export function isThreadPosted(thread: $TSFixMe) {
    return !thread.isStub && !thread.isDraft;
}
